export const ORGS = [ 'El Confidencial', 'Civio', 'Otros' ]
